import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import MedicineImage from '../assets/img/ongo/med.webp';
import AfterSchoolImage from '../assets/img/ongo/Afterschool.webp';
import CapabilityImage from '../assets/img/ongo/Capabality.webp';

const ongoingProjects = [
  {
    title: 'Medicine Support',
    description:
      'The Medicine Support program is dedicated to offering medical assistance to families in Bole Subcity, particularly those affected by HIV/AIDS. This initiative helps alleviate the burden of healthcare costs by providing the expenses for Medicine and Medical checkups',
    image: MedicineImage,
  },
  {
    title: 'After-School Program for Children',
    description:
      'Our After-School Program provides underprivileged children with a safe environment where they can receive tutoring, nutrition, and partake in creative activities. This program seeks to fill the educational and nutritional gaps many children face.',
    image: AfterSchoolImage,
  },
  {
    title: 'Capability Building',
    description:
      'The Capability Building program empowers families in Bole Subcity by offering income-generating loans and financial education. We focus on enabling families to become self-sufficient and improve their economic status through small business support.',
    image: CapabilityImage,
  },
];

const Ongoing = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const sectionElement = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.2 }
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-8 w-full min-h-[80vh] bg-white"
    >
      {/* Content Container */}
      <div className="mx-auto flex flex-col items-center justify-center w-[90%] lg:w-[70%] gap-12 relative z-10">
        {/* Title */}
        <motion.div
          className="w-full space-y-6"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
          transition={{ duration: 1 }}
        >
          <p className="text-sm text-[#90444D] font-semibold uppercase tracking-wider font-playfair">
            Ongoing Projects
          </p>
          <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
            We Empower Both <span className="text-[#90444D] uppercase">children and elders</span> <br/>Through Compassionate Initiatives
          </h2>
        </motion.div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
          {ongoingProjects.map((project, idx) => (
            <motion.div
              key={idx}
              className="bg-gray-50 rounded-xl border border-gray-500 shadow-md overflow-hidden hover:shadow-lg transition duration-500 hover:scale-105"
              initial={{ opacity: 0, y: 30 }}
              animate={{
                opacity: inView ? 1 : 0,
                y: inView ? 0 : 30,
              }}
              transition={{ duration: 0.6, delay: idx * 0.3 }}
            >
              <img
                src={project.image}
                alt={project.title}
                className="h-48 w-full object-cover"
              />
              <div className="p-4 space-y-2">
                <h3 className="text-lg md:text-xl font-semibold font-playfair text-customGreen">
                  {project.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {project.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ongoing;
